
export default class Address {

    public placeId         : ID
    public address         : string

    constructor(data: any) {
        this.placeId      = _.get(data, "placeId", null)
        this.address      = _.get(data?.text, "text", "")
    }

    static initFromJson(data:JSONObject):Address {
        return new Address(
            data.placePrediction,
        )
    }

    toJSON():JSONObject {
        return {
            placeId     : this.placeId,
            address     : this.address
        }
    }
}
